import { CircularProgress, Skeleton, Stack, Typography, styled } from "@mui/material";
import React from "react";
import MessageChatCard from "./Items/MessageChatCard";
import AudioPlayerChatCard from "./Items/AudioPlayerChatCard";
import AtachmentChatCard from "./Items/AtachmentChatCard";
import { getCookie } from "services/utils/CookieHandler";
import moment from 'moment-jalaali';
import 'moment/locale/fa';

//chat window
//the chat user and admin see for chatting
//has 4 modes : text / audioplayer / attachment / attachment (handled same)

//types :
// 0 ====> string (message)
// 1 ====> string (voice)
// 2 ====> string (photo)
// 3 ====> string (video)
// 4 ====> string (miscs)

const ChatContainer = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        height: 100%;
        margin-top: ${theme.spacing(3)};
        padding: 0 16px;
    `
)

export default function ChatWindow({ data, loader }) {

    const loginInfo = getCookie("loginData")

    return (
        <ChatContainer spacing={2} className="chat-window" >
            {
                filterDataByDate(data)?.map((val, i) => {
                    return (
                        <Stack key={i}>
                            <Typography sx={{textAlign: "center", my: 2, color: "#B2B2B2"}}>{getPersianDate(moment(val[0].CreatedDate).format("jDD jMMMM"))}</Typography>
                            <Stack spacing={2}>
                                {
                                    val.map((val2, j) => {
                                        switch (val2.Type) {
                                            case 0 :
                                                return <MessageChatCard trigerToBottom={(val.length - 1) == j} isMine={val2.CreatedUserId == loginInfo.userId ? true : false} key={j} seen={val2.IsSeen} data={val2} />
                                            case 1 :
                                                return <AudioPlayerChatCard trigerToBottom={(val.length - 1) == j} isMine={val2.CreatedUserId == loginInfo.userId ? true : false} key={j} seen={val2.IsSeen} data={val2} />
                                            case 2 :
                                                return <AtachmentChatCard trigerToBottom={(val.length - 1) == j} isMine={val2.CreatedUserId == loginInfo.userId ? true : false} key={j} seen={val2.IsSeen} data={val2} />
                                            case 4 :
                                                return <AtachmentChatCard trigerToBottom={(val.length - 1) == j} isMine={val2.CreatedUserId == loginInfo.userId ? true : false} key={j} seen={val2.IsSeen} data={val2} />
                                            default :
                                                return <h1>No matching file types</h1>
                                        }
                                    })
                                }
                            </Stack>
                        </Stack>
                    )
                })
            }
            {
                loader &&
                <LoaderContainer spacing={2} direction='row' justifyContent="space-between" alignItems="center" sx={{background: "white"}}>
                    <Stack alignItems="flex-end">
                        <Skeleton width="200px" />
                        <Skeleton width="160px" />
                    </Stack>
                    <CircularProgress color="grey" />
                </LoaderContainer>
            }
        </ChatContainer>
    )
}

const filterDataByDate = (data) => {
    const result = data.reduce((acc, obj) => {
        const date = moment(obj.CreatedDate).format("YYYY-MM-DD");
        const existingGroup = acc.find(group => moment(group[0].CreatedDate).format("YYYY-MM-DD") === date);

        if (existingGroup) {
            existingGroup.push(obj);
        } else {
            acc.push([obj]);
        }

      return acc;
    }, []);

    return result;
}



function getPersianDate(jalaliDate) {
    const jalaliMonthToFarsi = {
      'Farvardin': 'فروردین',
      'Ordibehesht': 'اردیبهشت',
      'Khordaad': 'خرداد',
      'Tir': 'تیر',
      'Amordaad': 'مرداد',
      'Shahrivar': 'شهریور',
      'Mehr': 'مهر',
      'Aabaan': 'آبان',
      'Aazar': 'آذر',
      'Dey': 'دی',
      'Bahman': 'بهمن',
      'Esfand': 'اسفند'
    };

    const [day, month] = jalaliDate.split(' ');

    const farsiMonth = jalaliMonthToFarsi[month];

    const farsiDate = `${day} ${farsiMonth}`;

    return farsiDate;
}

const LoaderContainer = styled(Stack)(
    ({ theme }) => `
        border-radius: 12px;
        min-width: 10%;
        max-width: 300px;
        border: 1px solid rgba(238, 238, 238, 0.93);
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.10);
        padding: ${theme.spacing(1.5)} ${theme.spacing(2)};
    `
)
